import { render, staticRenderFns } from "./OrdenVentaCrud.vue?vue&type=template&id=0e348662&"
import script from "./OrdenVentaCrud.vue?vue&type=script&lang=js&"
export * from "./OrdenVentaCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports